import {useEffect, useRef} from 'react';
import type {LocalVideoTrack} from 'livekit-client';

export const PreviewVideo = ({track}: {track: LocalVideoTrack}) => {
    const ref = useRef<HTMLVideoElement>(null);
    useEffect(() => {
        const element = ref.current;
        if (!element) {
            return;
        }
        track.attach(element);
        return () => {
            track.detach(element);
        };
    }, [track]);
    return <video ref={ref} data-testid="group-call-lobby-preview" className="h-full w-full object-cover" style={{transform: 'scaleX(-1)'}} muted playsInline autoPlay/>;
};
